import React, { Fragment } from 'react'

export const childName = ({ gov_record = {} }) => gov_record.childFirstName || 'the child'
export const parentName = ({ gov_record = {} }) => gov_record.individualFirstName || 'their parent'

export const sendEnrolmentDetailsFields = ({ record }) => () => (
  <fieldset>
    Pull {childName(record)}
    &#x27;s and {parentName(record)}
    &#x27;s <abbr title="Care Registration Number">CRN</abbr> and{' '}
    <abbr title="Date of Birth">DOB</abbr> information from Xplor, and send it to the government.
    This may take a few moments
  </fieldset>
)

export const SendEnrolmentDetailsDone = ({ record }) => (
  <Fragment>
    {childName(record)}
    &#x27;s enrolment has been updated
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/send-enrolment-details/fields.jsx